import { NetClient } from "./NetClient.js";

export const NETWORK_INPUT_SEND_MS = 33;
export const NETWORK_ENABLED = true;

export function createNetworkClient({
  url,
  mapId,
  name,
  characterId,
  getSessionId,
  onStatus,
  onWelcome,
  onState,
  onPlayerJoined,
  onPlayerLeft,
  onProjectileSpawn,
  onProjectileHit,
  onCombatHit,
  onCombatSwing,
  onChatMessage,
  onBulletinBoardSnapshot,
}) {
  return new NetClient({
    url,
    roomId: mapId,
    name,
    characterId,
    getSessionId,
    onStatus: onStatus || (() => {}),
    onWelcome: onWelcome || (() => {}),
    onState: onState || (() => {}),
    onPlayerJoined: onPlayerJoined || (() => {}),
    onPlayerLeft: onPlayerLeft || (() => {}),
    onProjectileSpawn: onProjectileSpawn || (() => {}),
    onProjectileHit: onProjectileHit || (() => {}),
    onCombatHit: onCombatHit || (() => {}),
    onCombatSwing: onCombatSwing || (() => {}),
    onChatMessage: onChatMessage || (() => {}),
    onBulletinBoardSnapshot: onBulletinBoardSnapshot || (() => {}),
  });
}

export function stopNetworkClient(netClient) {
  if (netClient) {
    netClient.stop();
  }
}
